import dentalBooking from "./dental-booking";
import healthcareIntake from "./healthcare-intake";
import realestateShowing from "./realestate-showing";
import realestateQualification from "./realestate-qualification";
import restaurantOrders from "./restaurant-orders";
import restaurantReservation from "./restaurant-reservation";
import ecommerceSupport from "./ecommerce-support";
import ecommerceReturns from "./ecommerce-returns";
import localInquiry from "./local-inquiry";
import localEmergency from "./local-emergency";
import saasDemo from "./saas-demo";
import saasPricing from "./saas-pricing";

/**
 * Starter template registry.
 *
 * Each entry exposes:
 *   id        — slug used in URLs + telemetry
 *   industry  — top-level grouping in the Step 2 grid
 *   channel   — "chat" | "voice"
 *   title     — card title in the grid
 *   subtitle  — one-line description under the title
 *   config    — a full WizardConfig (same shape as parser response)
 */
export const TEMPLATES = [
  // Healthcare
  {
    id: "healthcare-dental-booking",
    industry: "Healthcare",
    channel: "voice",
    title: "Dental appointment booking",
    subtitle: "Answer the phone and book patients on your calendar.",
    config: dentalBooking,
  },
  {
    id: "healthcare-intake",
    industry: "Healthcare",
    channel: "chat",
    title: "New-patient intake",
    subtitle: "Collect demographics + history before the first visit.",
    config: healthcareIntake,
  },

  // Real estate
  {
    id: "realestate-showing",
    industry: "Real estate",
    channel: "voice",
    title: "Showing scheduler",
    subtitle: "Book property viewings and warm-transfer hot leads.",
    config: realestateShowing,
  },
  {
    id: "realestate-qualification",
    industry: "Real estate",
    channel: "chat",
    title: "Lead qualification",
    subtitle: "Qualify inbound buyers and sellers on your website.",
    config: realestateQualification,
  },

  // Restaurant
  {
    id: "restaurant-orders",
    industry: "Restaurant",
    channel: "voice",
    title: "Take orders (takeout / delivery)",
    subtitle: "Take phone orders and text the customer a confirmation.",
    config: restaurantOrders,
  },
  {
    id: "restaurant-reservation",
    industry: "Restaurant",
    channel: "voice",
    title: "Reservation booking",
    subtitle: "Take reservation calls and confirm via SMS.",
    config: restaurantReservation,
  },

  // E-commerce
  {
    id: "ecommerce-support",
    industry: "E-commerce",
    channel: "chat",
    title: "Order status & support",
    subtitle: "Look up orders and open tickets for the tough cases.",
    config: ecommerceSupport,
  },
  {
    id: "ecommerce-returns",
    industry: "E-commerce",
    channel: "chat",
    title: "Returns & exchanges",
    subtitle: "Verify, scope, and open RMA tickets automatically.",
    config: ecommerceReturns,
  },

  // Local services
  {
    id: "local-inquiry",
    industry: "Local services",
    channel: "chat",
    title: "Service inquiry intake",
    subtitle: "Capture leads and SMS the dispatcher for urgent jobs.",
    config: localInquiry,
  },
  {
    id: "local-emergency",
    industry: "Local services",
    channel: "voice",
    title: "Emergency dispatch routing",
    subtitle: "Triage after-hours calls and warm-transfer on-call techs.",
    config: localEmergency,
  },

  // SaaS / B2B
  {
    id: "saas-demo",
    industry: "SaaS / B2B",
    channel: "chat",
    title: "Demo qualifier",
    subtitle: "Qualify inbound leads on chat and book a demo.",
    config: saasDemo,
  },
  {
    id: "saas-pricing",
    industry: "SaaS / B2B",
    channel: "chat",
    title: "Pricing FAQ",
    subtitle: "Answer pricing questions and capture qualified leads.",
    config: saasPricing,
  },
];

export const INDUSTRIES = [
  { id: "healthcare", label: "Healthcare", emoji: "🏥" },
  { id: "real-estate", label: "Real estate", emoji: "🏡" },
  { id: "restaurant", label: "Restaurant", emoji: "🍽️" },
  { id: "ecommerce", label: "E-commerce", emoji: "🛒" },
  { id: "local-services", label: "Local services", emoji: "🛠️" },
  { id: "saas", label: "SaaS / B2B", emoji: "💼" },
];
